import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import App from "@/App";
import RequireAdmin from "@/auth/RequireAdmin";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

function AdminLoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-700 mx-auto"></div>
        <p className="mt-4 text-slate-700 font-medium">Yönetici paneli yükleniyor...</p>
      </div>
    </div>
  );
}

export default function AppRouter() {
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={
          <RequireAdmin>
            <Suspense fallback={<AdminLoadingFallback />}>
              <AdminApp />
            </Suspense>
          </RequireAdmin>
        }
      />
      <Route path="/*" element={<App />} />
    </Routes>
  );
}
